import React from 'react';
import { SkeletonPlaceholder } from '@carbon/react';
import styles from './gallery.module.scss';

const GallerySkeleton = () => (
  <SkeletonPlaceholder className={styles.skeleton} title="Gallery loader" />
);

export default GallerySkeleton;
